import React, { useEffect, useMemo, useRef } from 'react';
import ReactSuperSelect from 'react-super-select';
import cx from 'classnames';
import { differenceBy } from 'lodash/array';

import IconButton from '../../common/buttons/IconButton/IconButton';
import useMobileDevice from '../../common/hooks/useMobileDevice';
import { isDisabledAuthority } from '../pages/Calendar/CalendarUtils';

import './UserMultiSelect.scss';

export function UserMultiSelect({
  initialUsers,
  onChange,
  organizerUser,
  datasource,
  className,
  optionValueKey,
  disabled,
  label
}) {
  const isMobileDevice = useMobileDevice();

  const onChangeRef = useRef(onChange);
  const previousDatasourceRef = useRef(datasource);
  onChangeRef.current = onChange;

  const availableUsers = useMemo(() => differenceBy(datasource, initialUsers, p => p[optionValueKey]), [
    datasource,
    initialUsers,
    optionValueKey
  ]);

  useEffect(() => {
    const previousDatasource = previousDatasourceRef.current;
    if (previousDatasource !== datasource) {
      if (previousDatasource?.length > 0) {
        onChangeRef.current([]);
      }
      previousDatasourceRef.current = datasource;
    }
  }, [datasource]);

  return (
    <div className={cx('eds-users-select', className)}>
      <ReactSuperSelect
        controlId={'users-selector'}
        dataSource={availableUsers}
        clearable={false}
        searchable
        disabled={disabled}
        clearSearchOnSelection
        id={'users-selector'}
        initialValue={initialUsers}
        optionValueKey={optionValueKey}
        placeholder={label}
        multiple={true}
        deselectOnSelectedOptionClick={false}
        tags={true}
        closeOnSelectedOptionClick={true}
        customSelectedValueTemplateFunction={() => label}
        onChange={function(newSelectedUsers = []) {
          onChange(newSelectedUsers);
        }}
        customOptionTemplateFunction={item => <AppointmentUserInfo item={item} />}
      />
      <div className="selected-groups-container">
        <div className="selected-group">
          {initialUsers &&
            initialUsers.map((item, key) => (
              <div className={cx('group-item mt-3', { mobile: isMobileDevice })} key={key}>
                <AppointmentUserInfo
                  item={item}
                  showOrganizerLabel={organizerUser && organizerUser[optionValueKey] === item[optionValueKey]}
                  showDisabledLabel={isDisabledAuthority(item)}
                />
                <div className="button-container">
                  <IconButton color="grey" onClick={() => removeUser(item)}>
                    cancel
                  </IconButton>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  function removeUser(option) {
    onChange(initialUsers.filter(e => e !== option));
  }
}

function AppointmentUserInfo({ item, className, showOrganizerLabel = false, showDisabledLabel = false }) {
  return (
    <div className={cx('user-info', className)}>
      <div className="label">{item.label}</div>
      <div className="name">
        {`${item.firstName} ${item.lastName}`}
        {showOrganizerLabel && <span className="label lightgrey pl-1">{'Organizer'}</span>}
      </div>
      {showDisabledLabel && <div className="name c-p">DISABLED</div>}
    </div>
  );
}
